import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-ink text-sand grain print:hidden">
    <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-24 sm:px-10">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <LogoMark className="h-12 w-12" />
          <p className="mt-8 max-w-md text-sm leading-relaxed text-sand/80">
            We acknowledge the Gweagal people of the Dharawal nation, Traditional Custodians of the lands and waters of Kamay.
            We pay our respects to Elders past and present. Always was, always will be Aboriginal land.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-7">
          <p className="eyebrow text-amber">Explore</p>
          <ul className="mt-6 space-y-3 text-sm">
            {[["/programmes", "Training programmes"], ["/donate", "Donate"], ["/contact", "Contact & enquiries"], ["/register", "Create an account"]].map(([to, l]) => (
              <li key={to}><Link to={to} data-testid={`footer-link-${to.slice(1)}`} className="text-sand/85 transition-colors hover:text-ochre">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow text-amber">Get in touch</p>
          <ul className="mt-6 space-y-3 text-sm text-sand/85">
            <li><a href="mailto:GACenquiries@outlook.com" data-testid="footer-email" className="transition-colors hover:text-ochre">GACenquiries@outlook.com</a></li>
            <li><a href="tel:0416923905" data-testid="footer-phone" className="transition-colors hover:text-ochre">0416923905</a></li>
            <li data-testid="footer-location">[Suburb] NSW [Postcode]</li>
            <li data-testid="footer-hours">[Opening hours]</li>
            <li data-testid="footer-abn">ABN 30296574753</li>
            <li data-testid="footer-inc">INC 9334</li>
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="mt-24 select-none whitespace-nowrap font-display text-[18vw] font-semibold leading-[0.8] tracking-tighter text-sand/10">
        Gweagal
      </p>
      <div className="mt-8 flex flex-col justify-between gap-3 border-t border-sand/15 pt-6 text-xs text-sand/70 sm:flex-row">
        <span>© {new Date().getFullYear()} GAC — Gweagal Aboriginal Corporation</span>
        <span className="font-mono uppercase tracking-[0.2em]">Charity · Training · Community</span>
      </div>
    </div>
  </footer>
);
